// @flow
import React from 'react'
import i18n from 'i18next'
import { CSSTransition } from 'react-transition-group'
import LanguageSelector from '../../LanguageSelector'
import Link from '../../../Link'
import CategoryPanel from './CategoryPanel'
import InfoPanel from './InfoPanel'
import {
  MainWrapper,
  DrawerWrapper,
  DrawerContent,
  DrawerBody,
  DrawerFooter,
  TextInfo,
  ButtonHamburger,
  PanelWrapper,
  PanelHeader
} from './styles'

type Props = {
  hardCodedProducts: Object,
  productID: number,
  catalogID: string,
  color: string,
  isAuthenticated: boolean,
  language: string,
  availableLanguages: Array<Object>,
  multiLanguagesPaths: Object,
  changeLanguage: Function,
  links: Array<Object>,
  staticPageID: string,
  isOpen: boolean,
  toggleDrawer: Function,
  navigateTo: Function
}

type State = {
  activeCategory: string,
  wrapperHeight: number
}

class DrawerMobile extends React.Component<Props, State> {
  orientationChangeTimeout = null

  state = {
    activeCategory: '',
    wrapperHeight: window.innerHeight
  }

  componentDidMount () {
    window.addEventListener('orientationchange', this.updateWrapperHeight)
  }

  componentWillUnmount () {
    if (document.body) {
      document.body.classList.remove('overflow-hidden')
    }

    if (this.orientationChangeTimeout) {
      clearTimeout(this.orientationChangeTimeout)
    }

    window.removeEventListener('orientationchange', this.updateWrapperHeight)
  }

  updateWrapperHeight = () => {
    this.orientationChangeTimeout = this.afterOrientationChange()
  }

  afterOrientationChange = () => {
    setTimeout(() => {
      this.setState({ wrapperHeight: window.innerHeight })
    }, 100)
  }

  handleCategoryOnClick = (category: string) => {
    if (this.state.activeCategory === category) {
      this.setState({ activeCategory: '' })

      return
    }

    this.setState({ activeCategory: category })
  }

  handleOnClick = () => {
    this.props.toggleDrawer()

    if (!document.body) {
      return
    }

    if (this.props.isOpen) {
      document.body.classList.remove('overflow-hidden')

      return
    }

    document.body.classList.add('overflow-hidden')
  }

  render () {
    return (
      <MainWrapper>
        <ButtonHamburger
          onClick={this.handleOnClick}
          isOpen={this.props.isOpen}
        >
          <span />
        </ButtonHamburger>
        <CSSTransition
          in={this.props.isOpen}
          timeout={600}
          classNames='drawer-wrapper'
          unmountOnExit
        >
          <DrawerWrapper height={this.state.wrapperHeight}>
            <DrawerContent>
              <DrawerBody height={this.state.wrapperHeight}>
                <PanelWrapper>
                  <PanelHeader onClick={this.handleOnClick}>
                    <Link to={i18n.t('routes.HOME')}>
                      <p>{i18n.t(`catalog.seeEverything.all`)}</p>
                    </Link>
                  </PanelHeader>
                </PanelWrapper>
                {Object.keys(this.props.hardCodedProducts).map(
                  (category, index) => (
                    <CategoryPanel
                      key={`${this.props.productID}-${index}`}
                      productID={this.props.productID}
                      products={this.props.hardCodedProducts[category]}
                      category={category}
                      activeCategory={this.state.activeCategory}
                      onCategoryClick={this.handleCategoryOnClick}
                      onProductClick={this.handleOnClick}
                      catalogID={this.props.catalogID}
                    />
                  )
                )}
                <InfoPanel
                  activeCategory={this.state.activeCategory}
                  onCategoryClick={this.handleCategoryOnClick}
                  links={this.props.links}
                  staticPageID={this.props.staticPageID}
                />
              </DrawerBody>
              <DrawerFooter>
                <LanguageSelector
                  isAtMobileView
                  isAuthenticated={this.props.isAuthenticated}
                  language={this.props.language}
                  navigateTo={this.props.navigateTo}
                  availableLanguages={this.props.availableLanguages}
                  toggleDrawer={this.handleOnClick}
                  multiLanguagesPaths={this.props.multiLanguagesPaths}
                  changeLanguage={this.props.changeLanguage}
                />
                <TextInfo>
                  <a href={`tel:${i18n.t('contactInfo.phoneNumber')}`}>
                    {i18n.t('contactInfo.message')}
                    <br />
                    {i18n.t('contactInfo.phoneNumber')}
                  </a>
                  <b />
                </TextInfo>
              </DrawerFooter>
            </DrawerContent>
          </DrawerWrapper>
        </CSSTransition>
      </MainWrapper>
    )
  }
}

export default DrawerMobile
